import React from "react";
import { useNavigate } from "react-router-dom";

import "../Styles/index.css";

import DashboardUsuario from "./usuario/DashboardUsuario";

export default function IntranetUsuarioDashboardPage() {
  const navigate = useNavigate();

  return (
    <DashboardUsuario onNavigate={(to) => navigate(to)} />
  );
}
